import React from "react";

export default (props) => (
  <svg {...props} viewBox="0 0 20 20">
    <path d="M9.16667 11.1667H0V0H9.16667V11.1667ZM20 7.16667H10.8333V0H20V7.16667ZM9.16667 20H0V12.8333H9.16667V20ZM20 20H10.8333V8.83333H20V20Z" />
  </svg>
);
